import * as HookForm from '@hookform/error-message'
import styles from './styles.module.css'

export default function ErrorMessage({ name }) {
    if (!name) {
        return null
    }

    return <HookForm.ErrorMessage name={name} as={<Error />} />
}

function Error({ children }) {
    if (!children) {
        return null
    }

    return <small className={styles.Error}>{children}</small>
}
